import tags from '../tags';

const {
  elements: { poison, cold, physical },
  skillTypes: {
    cc,
    dot,
    weaken,
    resource,
    cooldown,
    damageBoost,
    toughness,
    mobility,
    pet,
    healing,
  },
  skillTrees: {
    primary,
    secondary,
    corpses,
    reanimation,
    curses,
    bloodAndBone,
  },
} = tags;

export default [
  {
    name: 'Bone Spikes',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, dot, physical],
      },
      {
        name: 'Sudden Impact',
        tags: [primary, dot, cc, physical],
      },
      {
        name: 'Bone Pillars',
        tags: [primary, dot, poison],
      },
      {
        name: 'Frost Spikes',
        tags: [primary, dot, cold, cc],
      },
      {
        name: 'Path of Bones',
        tags: [primary, dot, physical],
      },
      {
        name: 'Blood Spikes',
        tags: [primary, dot, healing, physical],
      },
    ],
  },
  {
    name: 'Bone Spear',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, physical],
      },
      {
        name: 'Blighted Marrow',
        tags: [secondary, poison],
      },
      {
        name: 'Teeth',
        tags: [secondary, physical],
      },
      {
        name: 'Crystallization',
        tags: [secondary, weaken, damageBoost, cold],
      },
      {
        name: 'Shatter',
        tags: [secondary, physical],
      },
      {
        name: 'Blood Spear',
        tags: [secondary, physical],
      },
    ],
  },
  {
    name: 'Grim Scythe',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical],
      },
      {
        name: 'Execution',
        tags: [primary, physical],
      },
      {
        name: 'Dual Scythes',
        tags: [primary, physical, cc],
      },
      {
        name: 'Cursed Scythe',
        tags: [primary, poison, weaken],
      },
      {
        name: 'Frost Scythe',
        tags: [primary, cold, damageBoost],
      },
      {
        name: 'Blood Scythe',
        tags: [primary, physical, healing],
      },
    ],
  },
  {
    name: 'Corpse Explosion',
    runes: [
      {
        name: 'No Rune',
        tags: [corpses, physical],
      },
      {
        name: 'Bloody Mess',
        tags: [corpses, physical],
      },
      {
        name: 'Close Quarters',
        tags: [corpses, poison],
      },
      {
        name: 'Shrapnel',
        tags: [corpses, poison],
      },
      {
        name: 'Dead Cold',
        tags: [corpses, cold, cc],
      },
      {
        name: 'Final Embrace',
        tags: [corpses, physical],
      },
    ],
  },
  {
    name: 'Skeletal Mage',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, pet, physical],
      },
      {
        name: 'Gift of Death',
        tags: [secondary, pet, physical],
      },
      {
        name: 'Contamination',
        tags: [secondary, pet, poison],
      },
      {
        name: 'Skeleton Archer',
        tags: [secondary, pet, cold, damageBoost],
      },
      {
        name: 'Singularity',
        tags: [secondary, pet, physical],
      },
      {
        name: 'Life Support',
        tags: [secondary, pet, physical],
      },
    ],
  },
  {
    name: 'Corpse Lance',
    runes: [
      {
        name: 'No Rune',
        tags: [corpses, physical],
      },
      {
        name: 'Shredding Splinters',
        tags: [corpses, poison, weaken],
      },
      {
        name: 'Brittle Touch',
        tags: [corpses, cold, weaken],
      },
      {
        name: 'Ricochet',
        tags: [corpses, poison],
      },
      {
        name: 'Visceral Impact',
        tags: [corpses, physical, cc],
      },
      {
        name: 'Blood Lance',
        tags: [corpses, physical],
      },
    ],
  },
  {
    name: 'Command Skeletons',
    runes: [
      {
        name: 'No Rune',
        tags: [reanimation, pet, physical],
      },
      {
        name: 'Enforcer',
        tags: [reanimation, pet, physical],
      },
      {
        name: 'Frenzy',
        tags: [reanimation, pet, physical],
      },
      {
        name: 'Dark Mending',
        tags: [reanimation, pet, physical, healing],
      },
      {
        name: 'Freezing Grasp',
        tags: [reanimation, pet, cold],
      },
      {
        name: 'Kill Command',
        tags: [reanimation, pet, poison],
      },
    ],
  },
  {
    name: 'Siphon Blood',
    runes: [
      {
        name: 'No Rune',
        tags: [primary, physical, healing],
      },
      {
        name: 'Blood Sucker',
        tags: [primary, physical, healing],
      },
      {
        name: 'Suppress',
        tags: [primary, cold, healing, cc],
      },
      {
        name: 'Power Shift',
        tags: [primary, poison, healing],
      },
      {
        name: 'Purity of Essence',
        tags: [primary, physical, healing],
      },
      {
        name: 'Drain Life',
        tags: [primary, physical, healing],
      },
    ],
  },
  {
    name: 'Death Nova',
    runes: [
      {
        name: 'No Rune',
        tags: [secondary, poison],
      },
      {
        name: 'Unstable Compound',
        tags: [secondary, poison],
      },
      {
        name: 'Tendril Nova',
        tags: [secondary, healing, physical],
      },
      {
        name: 'Blight',
        tags: [secondary, poison, cc, weaken],
      },
      {
        name: 'Bone Nova',
        tags: [secondary, physical],
      },
      {
        name: 'Blood Nova',
        tags: [secondary, physical],
      },
    ],
  },
  {
    name: 'Command Golem',
    runes: [
      {
        name: 'No Rune',
        tags: [reanimation, cooldown, pet, physical],
      },
      {
        name: 'Flesh Golem',
        tags: [reanimation, cooldown, pet, physical],
      },
      {
        name: 'Ice Golem',
        tags: [reanimation, cooldown, pet, cold, cc, weaken],
      },
      {
        name: 'Bone Golem',
        tags: [reanimation, cooldown, pet, physical, cc, dot],
      },
      {
        name: 'Decay Golem',
        tags: [reanimation, cooldown, pet, poison],
      },
      {
        name: 'Blood Golem',
        tags: [reanimation, cooldown, pet, physical, healing],
      },
    ],
  },
  {
    name: 'Decrepify',
    runes: [
      {
        name: 'No Rune',
        tags: [curses, cc, weaken, physical],
      },
      {
        name: 'Dizzying Curse',
        tags: [curses, cc, weaken, physical],
      },
      {
        name: 'Enfeeblement',
        tags: [curses, cc, weaken, physical],
      },
      {
        name: 'Opportunist',
        tags: [curses, cc, weaken, mobility, physical],
      },
      {
        name: 'Wither',
        tags: [curses, weaken, physical],
      },
      {
        name: 'Borrowed Time',
        tags: [curses, cc, weaken, cooldown, physical],
      },
    ],
  },
  {
    name: 'Devour',
    runes: [
      {
        name: 'No Rune',
        tags: [corpses, resource, physical],
      },
      {
        name: 'Satiated',
        tags: [corpses, resource, toughness, physical],
      },
      {
        name: 'Ruthless',
        tags: [corpses, resource, physical],
      },
      {
        name: 'Devouring Aura',
        tags: [corpses, resource, physical],
      },
      {
        name: 'Voracious',
        tags: [corpses, resource, physical],
      },
      {
        name: 'Cannibalize',
        tags: [corpses, resource, healing, physical],
      },
    ],
  },
  {
    name: 'Leech',
    runes: [
      {
        name: 'No Rune',
        tags: [curses, healing, physical],
      },
      {
        name: 'Transmittable',
        tags: [curses, healing, physical],
      },
      {
        name: 'Osmosis',
        tags: [curses, healing, physical],
      },
      {
        name: 'Blood Flask',
        tags: [curses, healing, cooldown, physical],
      },
      {
        name: 'Sanguine End',
        tags: [curses, healing, physical],
      },
      {
        name: 'Cursed Ground',
        tags: [curses, healing, physical],
      },
    ],
  },
  {
    name: 'Bone Armor',
    runes: [
      {
        name: 'No Rune',
        tags: [bloodAndBone, physical, toughness],
      },
      {
        name: 'Vengeful Armaments',
        tags: [bloodAndBone, physical, toughness],
      },
      {
        name: 'Dislocation',
        tags: [bloodAndBone, poison, toughness, cc],
      },
      {
        name: 'Limited Immunity',
        tags: [bloodAndBone, physical, toughness],
      },
      {
        name: 'Harvest of Anguish',
        tags: [bloodAndBone, cold, toughness, mobility],
      },
      {
        name: 'Thy Flesh Sustained',
        tags: [bloodAndBone, physical, toughness, healing],
      },
    ],
  },
  {
    name: 'Army of the Dead',
    runes: [
      {
        name: 'No Rune',
        tags: [reanimation, physical],
      },
      {
        name: 'Blighted Grasp',
        tags: [reanimation, poison],
      },
      {
        name: 'Death Valley',
        tags: [reanimation, physical, cc],
      },
      {
        name: 'Unconventional Warfare',
        tags: [reanimation, physical],
      },
      {
        name: 'Frozen Army',
        tags: [reanimation, cold],
      },
      {
        name: 'Dead Storm',
        tags: [reanimation, physical, dot],
      },
    ],
  },
  {
    name: 'Frailty',
    runes: [
      {
        name: 'No Rune',
        tags: [curses, weaken, physical],
      },
      {
        name: 'Scent of Blood',
        tags: [curses, weaken, physical],
      },
      {
        name: 'Volatile Death',
        tags: [curses, weaken, physical],
      },
      {
        name: 'Aura of Frailty',
        tags: [curses, weaken, physical],
      },
      {
        name: 'Harvest Essence',
        tags: [curses, weaken, resource, physical],
      },
      {
        name: 'Early Grave',
        tags: [curses, weaken, physical],
      },
    ],
  },
  {
    name: 'Revive',
    runes: [
      {
        name: 'No Rune',
        tags: [corpses, pet, physical],
      },
      {
        name: 'Personal Army',
        tags: [corpses, pet, physical, toughness],
      },
      {
        name: 'Horrific Return',
        tags: [corpses, pet, poison, cc],
      },
      {
        name: 'Purgatory',
        tags: [corpses, pet, physical],
      },
      {
        name: 'Recklessness',
        tags: [corpses, pet, cold],
      },
      {
        name: 'Oblation',
        tags: [corpses, pet, physical],
      },
    ],
  },
  {
    name: 'Bone Spirit',
    runes: [
      {
        name: 'No Rune',
        tags: [bloodAndBone, physical],
      },
      {
        name: 'Astral Projection',
        tags: [bloodAndBone, cold],
      },
      {
        name: 'Panic Attack',
        tags: [bloodAndBone, poison, cc],
      },
      {
        name: 'Poltergeist',
        tags: [bloodAndBone, physical],
      },
      {
        name: 'Unfinished Business',
        tags: [bloodAndBone, cold],
      },
      {
        name: 'Possession',
        tags: [bloodAndBone, cc, physical],
      },
    ],
  },
  {
    name: 'Blood Rush',
    runes: [
      {
        name: 'No Rune',
        tags: [bloodAndBone, mobility, physical],
      },
      {
        name: 'Potency',
        tags: [bloodAndBone, mobility, toughness, physical],
      },
      {
        name: 'Transfusion',
        tags: [bloodAndBone, mobility, healing, physical],
      },
      {
        name: 'Molting',
        tags: [bloodAndBone, mobility, physical],
      },
      {
        name: 'Hemostasis',
        tags: [bloodAndBone, mobility, physical],
      },
      {
        name: 'Metabolism',
        tags: [bloodAndBone, mobility, physical],
      },
    ],
  },
  {
    name: 'Land of the Dead',
    runes: [
      {
        name: 'No Rune',
        tags: [reanimation, resource, physical],
      },
      {
        name: 'Frozen Lands',
        tags: [reanimation, resource, cc, cold],
      },
      {
        name: 'Plaguelands',
        tags: [reanimation, resource, poison],
      },
      {
        name: 'Shallow Graves',
        tags: [reanimation, resource, physical],
      },
      {
        name: 'Invigoration',
        tags: [reanimation, resource, physical],
      },
      {
        name: 'Land of Plenty',
        tags: [reanimation, resource, healing, physical],
      },
    ],
  },
  {
    name: 'Simulacrum',
    runes: [
      {
        name: 'No Rune',
        tags: [bloodAndBone, damageBoost, physical],
      },
      {
        name: 'Cursed Form',
        tags: [bloodAndBone, damageBoost, physical],
      },
      {
        name: 'Reservoir',
        tags: [bloodAndBone, damageBoost, resource, physical],
      },
      {
        name: 'Self Sacrifice',
        tags: [bloodAndBone, damageBoost, healing, physical],
      },
      {
        name: 'Blood Debt',
        tags: [bloodAndBone, damageBoost, physical],
      },
      {
        name: 'Blood and Bone',
        tags: [bloodAndBone, damageBoost, physical],
      },
    ],
  },
];
